export default {
    attributions:           { method: 'get',    url: 'attributions' },
    attributionsId:         { method: 'get',    url: 'attributions/{id}' },
    createAttribution:      { method: 'post',   url: 'attributions'},
    updateAttribution:      { method: 'put',    url: 'attributions/{id}'},
    deleteAttribution:      { method: 'delete', url: 'attributions/{id}'},
    attributionsToken:      { method: 'get',    url: 'attributions/{token}/token' },
    finalizeAttribution:    { method: 'post',   url: 'attributions/finalize/{id}'},
    removeAttribution:      { method: 'post',   url: 'attributions/remove/{id}'},
}